import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

import { SanfoGraficoMetragem } from "../../../components/Sanforizadeira/GraficoMetragem";
import { SanfoGraficoTurma } from "../../../components/Sanforizadeira/GraficoTurma";
import { SanfoGraficoOperador } from "../../../components/Sanforizadeira/GraficoOperador";
import { RevisaoGraficoSetorMes } from "../../../components/Revisao/GraficoSetorMes";

const labels = [
    { label: "Registros", value: 1 },
    { label: "Turmas", value: 2 },
    { label: "Gráficos", value: 3 }
];

const initialData = {
    periodo: "",
    rolos: [],
    turmas: []
}

const headers = ['metrostecelagem', 'cod_tear', 'nomerolo', 'lote', 'cod_artigo', 'datafinalsanfor', 'horafinalsanfor',
    'dataentacab', 'horaentacab', 'dataentsanfof', 'horaentsanfo', 'velocidade', 'colaborador', 'turma', 'tempo_processo', 'tempo_esperado', 'eficiencia',
    'segundos_tempo_esperado', 'segundos_tempo_processo', 'tempo']

export default function DashboardSanforizadeira() {
    const [data, setData] = useState(initialData);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());

    const [optionSelected, setOptionSelected] = useState(1);

    const [isLoading, setIsLoading] = useState(false);

    const toast = useRef();

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("acabamento").then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setData(initialData);
            setIsLoading(false);
        });
    }, []);

    const handleDownload = async () => {
        const { utils, writeFileXLSX } = await import("xlsx");
        let copy = [...data.rolos];

        const filteredData = copy.map(obj => {
            const filteredObj = {};
            for (const key in obj) {
                if (headers.includes(key)) {
                    filteredObj[key] = obj[key];
                }
            }
            return filteredObj;
        });

        const workbook = utils.book_new();
        const worksheet = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(workbook, worksheet, "Sheet1");
        writeFileXLSX(workbook, "registros.xlsx");
    }

    const handleSearch = () => {

        let params = {};
        params.data_inicial = initialDate.getFullYear() + "-" + String(initialDate.getMonth() + 1).padStart(2, "0") + "-" + String(initialDate.getDate()).padStart(2, "0");
        params.data_final = finalDate.getFullYear() + "-" + String(finalDate.getMonth() + 1).padStart(2, "0") + "-" + String(finalDate.getDate()).padStart(2, "0");

        setIsLoading(true);
        api.get("acabamento", {
            params: params
        }).then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setData(initialData);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if (isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Card
                className="p-m-1"
                title="Dashboard Sanforizadeira"
                subTitle={"Período - " + data?.periodo}
            >
                <div className="p-grid">
                    {labels.map((item, index) => (
                        <Button
                            className={"p-m-1 p-button-secondary p-col " + (optionSelected === item.value ? "p-button-success" : "")}
                            key={`button${index}`}
                            label={item.label}
                            onClick={() => setOptionSelected(item.value)}
                        />
                    ))}
                </div>


                <div className="p-d-flex p-flex-row p-justify-between">
                    <div>
                        <Calendar
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setInitialDate(e.value)}
                            value={initialDate}
                        />

                        <Calendar
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setFinalDate(e.value)}
                            value={finalDate}
                        />

                        <Button
                            className="p-m-1"
                            icon="pi pi-search"
                            onClick={handleSearch}
                        />
                    </div>
                </div>

                <div style={{ display: optionSelected === 1 ? "block" : "none" }}>
                    <div className="p-d-flex p-flex-row">
                        <Button
                            className="p-m-1 p-button-success"
                            icon="pi pi-file-excel"
                            onClick={handleDownload}
                        />
                    </div>

                    <DataTable
                        rowHover
                        stripedRows
                        size="small"
                        value={data.rolos}
                    >
                        <Column header="Data" field="dataentsanfof" sortable />
                        <Column header="N Rolo" field="nomerolo" sortable />
                        <Column header="H.I" field="horaentsanfo" />
                        <Column header="H.F" field="horafinalsanfor" />
                        <Column header="Tempo Processo" field="tempo_processo" />
                        <Column header="Tempo Esperado" field="tempo_esperado" />
                        <Column header="Eficiência" field="eficiencia" sortable />
                        <Column header="Artigo" field="cod_artigo" sortable />
                        <Column header="Tear" field="cod_tear" sortable />
                        <Column header="Metragem" field="metrofinal" sortable />
                        <Column header="Velocidade" field="velocidade" sortable />
                        <Column header="Colaborador" field="colaborador" sortable />
                        <Column header="Turma" field="turma" sortable />
                    </DataTable>
                </div>

                <div style={{ display: optionSelected === 2 ? "block" : "none" }} >
                    {data.turmas.map((turma, index) => (
                        <div key={`turma${index}`} style={{ border: "1px solid black", borderRadius: 4, marginBottom: 16, padding: 8 }}>
                            <div className="p-grid">
                                <div className="p-col-2">
                                    <h3 className="p-m-2 p-p-2" style={{ backgroundColor: "#3498db", borderRadius: 4, color: "#fff", width: 300 }}>TURMA {turma.turma}</h3>
                                    <ul>
                                        {turma.colaboradores.map((colaborador, index) => (
                                            <li key={`colaborador${index}`} >{colaborador}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="p-col-10">
                                    <DataTable
                                        className="p-m-2"
                                        size="small"
                                        value={turma.dados}
                                    >
                                        <Column header="Tempo Processo" field="tempo_processo" />
                                        <Column header="Tempo Esperado" field="tempo_esperado" />
                                        <Column header="Tempo Computado" field="tempo_computado" />
                                        <Column header="Eficiência" field="eficiencia" />
                                        <Column header="Defeitos" field="defeitos" />
                                        <Column header="Qualidade" field="qualidade" />
                                        <Column header="Reprocesso" field="reprocesso" />
                                        <Column header="Metros" field="producao" />
                                    </DataTable>
                                </div>

                                <div className="p-col-2"></div>
                                <div className="p-col-10">
                                    <h3 className="p-m-2">Prêmio: </h3>
                                    <ul>
                                        <li><h3>Prêmio Produção: {turma.dados[0].producao_premio}%</h3></li>
                                        <li><h3>Prêmio Defeitos: {turma.dados[0].defeitos_premio}%</h3></li>
                                        <li><h3>Prêmio Reprocesso: {turma.dados[0].reprocesso_premio}%</h3></li>
                                        {turma.dados[0].qualidade > 2 && (
                                            <>
                                                <br></br>
                                                <li>
                                                    <h4 className="p-m-1" >
                                                        Observação: Para atingir a premiação de defeitos, a turma {turma.turma} precisa
                                                        rodar {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(turma.dados[0].defeitos / 0.02 - turma.dados[0].producao)}m sem cometer defeitos
                                                    </h4>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>

                                <div className="p-col-2"></div>
                                <div className="p-col-10">
                                    <RevisaoGraficoSetorMes
                                        data={data.defeitos_tipo.filter((element) => { return element.turma === turma.turma })}
                                        colProp="p-col-12"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ display: optionSelected === 3 ? "block" : "none" }}>
                    <SanfoGraficoMetragem
                        data={data.rolos}
                    />

                    <SanfoGraficoTurma
                        data={data.turmas}
                    />

                    <SanfoGraficoOperador
                        data={data.rolos}
                    />
                </div>
            </Card>
        </div>
    )
}
